import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { PageServiceService } from 'src/app/Services/page-service.service';

@Component({
  selector: 'ze-add-api-object',
  templateUrl: './add-api-object.component.html',
  styleUrls: ['./add-api-object.component.scss']
})
export class AddApiObjectComponent implements OnInit {
  newApiObject: any;
  authTypes = ['noauth', 'apikey', 'bearer', 'basic', 'oauth1', 'oauth2', 'ntlm', 'digest', 'hawk', 'aws'];
  bodyModes = ['none', 'raw', 'urlencoded', 'formdata', 'file', 'graphql'];
  bodyDefaults: Record<string, any> = {
    raw: '',
    formdata: [],
    urlencoded: [],
    file: { src: '' },
    graphql: { query: '', variables: '' }
  };
  authDefaults: Record<string, any> = {
    noauth: {},
    apikey: { key: '', value: '', in: 'header' },
    bearer: { token: '' },
    basic: { username: '', password: '' },
    oauth1: {
      consumerKey: '', consumerSecret: '', token: '', tokenSecret: '',
      signatureMethod: '', timestamp: '', nonce: '', version: ''
    },
    oauth2: {
      token: '', headerPrefix: '', addTokenTo: 'header',
      clientId: '', clientSecret: '', accessToken: '', grant_type: 'authorization_code',
      accessTokenUrl: '', scope: '', username: '', password: '', tokenName: '', authUrl: '', redirect_uri: '', refreshTokenUrl: '', client_authentication: '', state: '', useBrowser: false, code_verifier: '', challengeAlgorithm: ''
    },
    ntlm: { username: '', password: '', domain: '', workstation: '' },
    digest: {
      username: '', password: '', algorithm: 'SHA-256',
      realm: '', nonce: '', qop: ''
    },
    hawk: { id: '', key: '', algorithm: 'sha256', user: '' },
    aws: { accessKey: '', secretKey: '', region: '', service: '' }
  };
  rawLanguages = ['json', 'javascript', 'text', 'html', 'xml'];
  rawValidationError: string | null = null;
  public selectedWebPageId: any;
  public selectedWebPageName: any;
  public selectedElement;
  webpages: any = [];
  webpage: string = "";
  newWP: any;
  showModal: string = 'selectWebPageOption';
  public filterdWebPages = [];
  // public webpageSearch = "";
  public webpagedb2: any;
  public stepId;
  displayValue: any = "";
  showCreateOption: boolean = false;
  hideSearchBox: boolean = true;
  isStudioPage: boolean = false;
  public currentPageName: string;
  public selectedWebPage: any;
  @ViewChild('apiform', {static: false}) apiform!: NgForm;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public dialogRef: MatDialogRef<any>,
    private pageService: PageServiceService,) { 
      data.element == undefined ? this.newApiObject = {
        webpageId: { $oid: "" },
        name: '',
        validationTemplate: '',
        request: {
          url: {
            raw: '',
            protocol: '',
            host: [],
            port: '',
            path: [], 
            query_params: []
          },
          headers: [],
          body: {
            mode: 'none',
            raw: '',
            urlencoded: [],
            formdata: [],
            file: { src: '' },
            graphql: { query: '', variables: '' },
            options: { raw: { language: 'json' } }
          },
          auth: {
            type: 'noauth',
            noauth: {},
            apikey: { key: '', value: '', in: 'header' },
            bearer: { token: '' },
            basic: { username: '', password: '' },
            oauth1: { consumerKey: '', consumerSecret: '', token: '', tokenSecret: '', signatureMethod: '', timestamp: '', nonce: '', version: '' },
            oauth2: { token: '', headerPrefix: '', addTokenTo: '', clientId: '', clientSecret: '', accessToken: '', grant_type: 'authorization_code', accessTokenUrl: '', scope: '', username: '', password: '', tokenName: '', authUrl: '', redirect_uri: '', refreshTokenUrl: '', client_authentication: '', state: '', useBrowser: false, code_verifier: '', challengeAlgorithm: '' },
            ntlm: { username: '', password: '', domain: '', workstation: '' },
            digest: { username: '', password: '', algorithm: 'SHA-256', realm: '', nonce: '', qop: '' },
            hawk: { id: '', key: '', algorithm: 'sha256', user: '' },
            aws: { accessKey: '', secretKey: '', region: '', service: '' }
          }
        }
      } : this.assignApiObject(data.element);
      this.selectedWebPageId = data.webpage ? data.webpage : '';
      this.showModal = data.showView ? data.showView : this.showModal;
      this.stepId = data.stepId;
      if (this.router.url.includes('/canvas')) {
        this.isStudioPage = false;
        this.getWebPagesdb2();
      }
      else {
        this.isStudioPage = true;
        this.newApiObject.changedwebpageId = "";
        this.getWebPages();
      }
  }

  assignApiObject(objectModel) {
    const authArray = objectModel.request.auth[objectModel.request.auth.type];

    if (Array.isArray(authArray)) {
      objectModel.request.auth[objectModel.request.auth.type] = authArray.reduce((acc, item) => {
        if (item.key) {
          acc[item.key] = item.value;
        }
        return acc;
      }, {});
    }

    this.newApiObject = objectModel;
  }

  convertAuthObjectToArray() {
    const authType = this.newApiObject.request.auth.type;
    const authData = this.newApiObject.request.auth[authType];
  
    if (authData && typeof authData === 'object' && !Array.isArray(authData)) {
      const authArray = Object.entries(authData).map(([key, value]) => ({
        key,
        value
      }));

      const newAuthObject = { "type": authType, [authType]: authArray };
  
      this.newApiObject.request.auth = JSON.parse(JSON.stringify(newAuthObject));
    }
  }

  ngOnInit() {
  }

  validateRawBody(rawBodyTextArea: NgModel) {
    const rawType = this.newApiObject.request.body.options.raw.language;
    const content = this.newApiObject.request.body.raw;
    if (content !== '') {
      try {
        const contentMatch = content.match(/\{\{(##|@@)[a-zA-Z0-9_]+\}\}/);
        if (!contentMatch) {
          switch (rawType) {
            case 'json':
              JSON.parse(content);
              break;
            case 'xml':
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(content, 'application/xml');
              if (xmlDoc.getElementsByTagName('parsererror').length > 0) {
                throw new Error('Invalid XML format');
              }
              break;
            case 'javascript':
              new Function(content); // basic JS syntax check
              break;
            case 'text':
            case 'html':
            default:
              // assume always valid
              break;
          }
        }
        this.rawValidationError = null;
        // rawBodyTextArea.control.setErrors({ invalidRawBody: false });
        if (rawBodyTextArea && rawBodyTextArea.control && rawBodyTextArea.control.errors && rawBodyTextArea.control.errors['invalidRawBody']) {
          const { invalidRawBody, ...otherErrors } = rawBodyTextArea.control.errors;
          rawBodyTextArea.control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
        }
      } catch (e) {
        this.rawValidationError = e.message;
        if (rawBodyTextArea && rawBodyTextArea.control && rawBodyTextArea.control) {
          rawBodyTextArea.control.setErrors({ invalidRawBody: true });
        }
      }
    } else {
      this.rawValidationError = null;
      // rawBodyTextArea.control.setErrors({ invalidRawBody: false });
      if (rawBodyTextArea && rawBodyTextArea.control && rawBodyTextArea.control.errors && rawBodyTextArea.control.errors['invalidRawBody']) {
        const { invalidRawBody, ...otherErrors } = rawBodyTextArea.control.errors;
        rawBodyTextArea.control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
      }
    }
  }

  onUrlChange(urlControl: NgModel) {
    const rawUrl: string = this.newApiObject.request.url.raw || '';

    // Enhanced regex to extract protocol, host+port, path, and query string
    // const urlRegex = /^(?:(?:[a-zA-Z0-9#@{}]+):\/\/)?([a-zA-Z0-9#@{}.]+(?:\:(?:[a-zA-Z0-9#@{}]+))?)(?:\/(?:[a-zA-Z0-9#@{}\/]*))?(?:\?.*)?$/;
    const urlRegex = /^(?:(?:[a-zA-Z0-9#@{}]+):\/\/)?([a-zA-Z0-9&-=#@{}.:]+)(?:\/(?:[a-zA-Z0-9&-=#@{}\/]*))?(?:\?.*)?$/;

    const match = rawUrl.match(urlRegex);

    let protocol = '';
    let host = [];
    let port = '';
    let path = [];
    let query_params: { key: string; value: string }[] = [];

    if (match) {
      // Extract host and port from capturing group 1
      const hostPort = match[1] || '';
      if (hostPort.includes(':')) {
        const lastColonIndex = hostPort.lastIndexOf(':');
        const hostStr = hostPort.substring(0, lastColonIndex);
        const portStr = hostPort.substring(lastColonIndex + 1);
        host = hostStr.split('.').filter(Boolean);
        port = portStr;
      } else {
        host = hostPort.split('.').filter(Boolean);
      }

      // Extract path manually by removing protocol and hostPort from rawUrl
      // Find index of hostPort in rawUrl
      const hostPortIndex = rawUrl.indexOf(hostPort);
      if (hostPortIndex !== -1) {
        // Extract protocol manually by looking at the start of rawUrl before "://"
        const protocolMatch = rawUrl.substring(0, hostPortIndex).match(/^([a-zA-Z0-9#@{}]+):\/\//);
        protocol = protocolMatch ? protocolMatch[1] : '';

        // Path and query start after hostPort
        const afterHostPort = rawUrl.substring(hostPortIndex + hostPort.length);

        // Path is portion starting with '/', up to '?' or end of string
        const pathMatch = afterHostPort.match(/\/[a-zA-Z0-9#@{}\/]*/);
        if (pathMatch) {
          path = pathMatch[0].substring(1).split('/');
        }

        // Query is portion starting with '?'
        const queryMatch = afterHostPort.match(/\?.*$/);
        if (queryMatch) {
          const queryStr = queryMatch[0].substring(1); // remove '?'
          query_params = queryStr.split('&').filter(Boolean).map(param => {
            const [key, value] = param.split('=');
            return { key, value };
          });
        }
      }
      this.newApiObject.request.url.query_params = query_params;

      // Clear validation errors if any
      urlControl.control.setErrors(null);
    } else {
      console.error('Invalid URL');      
      const rawUrl: string = this.newApiObject.request.url.raw || '';
      this.newApiObject.request.url.query_params = (rawUrl.split('?', 2)[1] || '')
        .split('&')
        // .filter(param => param.includes('='))
        .map(param => {
          const [key, value = ''] = param.split('=');
          return {
            key: key,
            value: value
          };
        });
      
      urlControl.control.setErrors({ invalid: true });
    }
    // Assign to object
    this.newApiObject.request.url.protocol = protocol;
    this.newApiObject.request.url.host = host;
    this.newApiObject.request.url.port = port;
    this.newApiObject.request.url.path = path;
  }

  updateRawUrlFromQueryParams() {
    try {
      const raw = this.newApiObject.request.url.raw || '';
      const rawWithoutQuery = raw.split("?")[0];
  
      // Construct query string from query_params
      const queryString = this.newApiObject.request.url.query_params
        .filter(param => param.key !== '') // skip empty keys
        .map(param => {
          return param.value ? `${param.key}=${param.value}` : param.key;
        })
        .join('&');
  
      // Construct full URL
      const url = `${rawWithoutQuery}${queryString ? '?' + queryString : ''}`;
  
      this.newApiObject.request.url.raw = url;
  
    } catch (error) {
      console.error('Error building raw URL:', error);
    }
  }
  
  addQueryParam() {
    this.newApiObject.request.url.query_params.push({ key: '', value: '' });
    this.updateRawUrlFromQueryParams();
  }

  removeQueryParam(index: number) {
    this.newApiObject.request.url.query_params.splice(index, 1);
    this.updateRawUrlFromQueryParams();
  }

  addHeader() {
    this.newApiObject.request.headers.push({ disabled: false, key: '', value: '', auto_generated: false });
  }

  removeHeader(index: number) {
    this.newApiObject.request.headers.splice(index, 1);
  }

  getHeaderTooltip(header): string {
    if ((header.key.toLowerCase() !== 'content-type' && header.key.toLowerCase() !== 'authorization') || header.disabled) return '';
  
    const contentTypeKey = (h) => h.key.toLowerCase() === 'content-type';
    const authorizationKey = (h) => h.key.toLowerCase() === 'authorization';
    const isNotDisabled = (h) => h.disabled === false;
    const isAuto = (h) => h.auto_generated === true;
    const isCustom = (h) => h.auto_generated === false || h.auto_generated === null || h.auto_generated === undefined;
  
    if (header.key.toLowerCase() === 'content-type') {
      // 1. Auto-generated content-type header for form/urlencoded
      if (header.auto_generated && (this.newApiObject.request.body.mode === 'formdata' || this.newApiObject.request.body.mode === 'urlencoded')) {
        const hasCustomSelected = this.newApiObject.request.headers.some(h =>
          contentTypeKey(h) && isNotDisabled(h) && isCustom(h)
        );
        if (hasCustomSelected) {
          return 'Auto-generated Content-Type will override custom-defined one for the selected body mode.';
        }
      }
    
      // 2. Custom content-type header for file/graphql
      if (!header.auto_generated && (this.newApiObject.request.body.mode === 'file' || this.newApiObject.request.body.mode === 'graphql' || this.newApiObject.request.body.mode === 'raw')) {
        const hasAutoSelected = this.newApiObject.request.headers.some(h =>
          contentTypeKey(h) && isNotDisabled(h) && isAuto(h)
        );
        if (hasAutoSelected) {
          return 'Your custom Content-Type will override the auto-generated one for the selected body mode.';
        }
      }
    } else if (header.key.toLowerCase() === 'authorization') {
      // 1. Auto-generated content-type header for form/urlencoded
      if (header.auto_generated && (this.newApiObject.request.auth.type === 'basic' || this.newApiObject.request.auth.type === 'bearer')) {
        const hasCustomSelected = this.newApiObject.request.headers.some(h =>
          authorizationKey(h) && isNotDisabled(h) && isCustom(h)
        );
        if (hasCustomSelected) {
          return 'Auto-generated Content-Type will override custom-defined one for the selected body mode.';
        }
      }
    }
  
    return '';
  }

  onBearerTokenChange(): void {
    const index = this.newApiObject.request.headers.findIndex(
      h => h.key.toLowerCase() === 'authorization' && h.auto_generated
    );
    if (index !== -1) {
      this.newApiObject.request.headers[index]["value"] = 'Bearer ' + this.newApiObject.request.auth.bearer.token;
    }
  }

  onBasicAuthDataChange(): void {
    const index = this.newApiObject.request.headers.findIndex(
      h => h.key.toLowerCase() === 'authorization' && h.auto_generated
    );
    if (index !== -1) {
      const { username, password } = this.newApiObject.request.auth.basic;
      const credentials = `${username}:${password}`;
      const encoded = btoa(credentials); // base64 encode
      this.newApiObject.request.headers[index]["value"] = 'Basic ' + encoded;
    }
  }

  onAuthChange(): void {
    const authType = this.newApiObject.request.auth.type;
    if (authType in this.authDefaults) {
      this.newApiObject.request.auth[authType] = this.newApiObject.request.auth[authType] || this.authDefaults[authType];
    }

    const index = this.newApiObject.request.headers.findIndex(
      h => h.key.toLowerCase() === 'authorization' && h.auto_generated
    );

    let value = '';
    switch (this.newApiObject.request.auth.type) {
      case 'basic':
        const { username, password } = this.newApiObject.request.auth.basic;
        const credentials = `${username}:${password}`;
        const encoded = btoa(credentials); // base64 encode
        value = 'Basic ' + encoded;
        break;
      case 'bearer':
        value = 'Bearer ' + this.newApiObject.request.auth.bearer.token;
        break;
      default:
        // Remove auto-generated Authorization header
        if (index !== -1) {
          this.newApiObject.request.headers.splice(index, 1);
        }     
        return;
    }

    const newHeader = { disabled: false, key: 'Authorization', value: value, auto_generated: true };
    const newHeadersArray = this.newApiObject.request.headers;

    if (index !== -1) {
      newHeadersArray[index] = newHeader;
    } else {
      newHeadersArray.splice(0, 0, newHeader); // Insert at beginning
    }

    this.newApiObject.request.headers = JSON.parse(JSON.stringify(newHeadersArray));
  }
  
  onBodyModeChange(): void {
    const mode = this.newApiObject.request.body.mode;
    if (mode in this.bodyDefaults) {
      this.newApiObject.request.body[mode] = this.newApiObject.request.body[mode] || this.bodyDefaults[mode];
    }
    if (mode == 'raw' && (this.newApiObject.request.body["options"] == undefined || this.newApiObject.request.body["options"] == null)) {
      this.newApiObject.request.body["options"] = { "raw": { "language": "json" } };
    }

    const index = this.newApiObject.request.headers.findIndex(
      h => h.key.toLowerCase() === 'content-type' && h.auto_generated
    );
  
    let value = '';
    switch (this.newApiObject.request.body.mode) {
      case 'formdata':
        value = 'multipart/form-data';
        break;
      case 'urlencoded':
        value = 'application/x-www-form-urlencoded';
        break;
      case 'file':
      case 'graphql':
        value = 'application/json';
        break;
      case 'raw':
        this.validateRawBody(this.newApiObject.request.body.raw);
        switch(this.newApiObject.request.body.options.raw.language) {
          case 'json':
            value = 'application/json';
            break;
          case 'javascript':
            value = 'application/javascript';
            break;
          case 'text':
            value = 'text/plain';
            break;
          case 'html':
            value = 'text/html';
            break;
          case 'xml':
            value = 'application/xml';
            break;
        }
        break;
      case 'none':
      default:
        // Remove auto-generated Content-Type header
        if (index !== -1) {
          this.newApiObject.request.headers.splice(index, 1);
        }        
      return;
    }

    const newHeader = { disabled: false, key: 'Content-Type', value: value, auto_generated: true };
    const newHeadersArray = this.newApiObject.request.headers;

    if (index !== -1) {
      newHeadersArray[index] = newHeader;
    } else {
      newHeadersArray.splice(0, 0, newHeader); // Insert at beginning
    }

    this.newApiObject.request.headers = JSON.parse(JSON.stringify(newHeadersArray));
  }

  addUrlEncodedParam() {
    this.newApiObject.request.body.urlencoded.push({ key: '', value: '' });
  }

  removeUrlEncodedParam(index: number) {
    this.newApiObject.request.body.urlencoded.splice(index, 1);
  }

  addFormDataParam() {
    this.newApiObject.request.body.formdata.push({ key: '', value: '', type: 'text', src: [''] });
  }

  removeFormDataParam(index: number) {
    this.newApiObject.request.body.formdata.splice(index, 1);
  }

  addFileInput(formDataIndex: number) {
    this.newApiObject.request.body.formdata[formDataIndex].src.push('');
  }
  
  removeFileInput(formDataIndex: number, fileIndex: number) {
    this.newApiObject.request.body.formdata[formDataIndex].src.splice(fileIndex, 1);
  }

  setRawLanguage(lang: string) {
    this.newApiObject.request.body.options.raw.language = lang;
  }


  // from webObjectAdd
  getValue(val: any) {
    this.displayValue = val;
    this.showCreateOption = false;
    let showCreateOptionflag = false;
    for (let webpage of this.webpages) {
      if (webpage.name == val) {
        showCreateOptionflag = true;
        break;
      }
    }
    if (!showCreateOptionflag) {
      this.showCreateOption = true;
    }
  }

  searchWebPage(searchfield) {
    this.filterdWebPages = this.webpages.filter(webpage => {
      return webpage.name.includes(searchfield);
    });
  }

  createPagebtn() {
    this.showModal = 'createpageoption';
    this.hideSearchBox = !this.hideSearchBox;
    this.newApiObject.wpname = this.displayValue;
    this.newApiObject.wpdesc = "";
    this.newApiObject.wpurl = "";
  }
  
  displayobject(page) {
    this.newApiObject.selectedWebPageId = page._id;
  }

  getcurrnetPageName(webPageId): String {
    return this.webpages.find((webpage) => {
      if (webpage._id.$oid == webPageId || webpage._id == webPageId) {
        this.webpage = webpage.name;
        return webpage;
      }
    })
  }

  getWebPages() {
    this.pageService.getItems().subscribe(data => {
      this.webpages = this.webpages.concat(data['data'].filter(Boolean));
      this.filterdWebPages = this.webpages.map(x => Object.assign({}, x));
      this.newApiObject.selectedWebPageId = this.selectedWebPageId;
    });
  }
  getWebPagesdb2() {
    this.pageService.getdb2Items().subscribe(data => {
      this.webpages = (data['data'].filter(Boolean));
      this.getWebPages();
    });
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  saveDialog() {
    // if (this.validateService.isPrimaryLocatorEmpty(this.newElement)) {
    //   this.notifys.notify('warning', 'Empty Primary Locator', "Primary locator value is empty");
    //   return;
    // }
    // if (this.newElement["priority"]) {
    //   if (this.newElement["priority"][0]["timeTaken"]["$numberLong"]) {
    //     this.newElement["priority"][0]["timeTaken"] = Number(this.newElement["priority"][0]["timeTaken"]["$numberLong"]);
    //   }
    // }
    this.convertAuthObjectToArray();
    const bodyMode = this.newApiObject.request.body.mode;
    const newBodyObject: any = {
      mode: bodyMode,
      [bodyMode]: this.newApiObject.request.body[bodyMode]
    };    
    if (bodyMode === 'raw') {
      newBodyObject.options = this.newApiObject.request.body.options;
    }
    this.newApiObject.type = "API";
    this.newApiObject.request.body = JSON.parse(JSON.stringify(newBodyObject));
    this.dialogRef.close(this.newApiObject);
  }

}
